import { Link } from "react-router-dom";

export default function BrandMark({ variant = "dark" }: { variant?: "dark" | "light" }) {
  const textColor = variant === "light" ? "text-accent-50" : "text-foreground-950";
  const subColor = variant === "light" ? "text-accent-200/80" : "text-foreground-500";

  return (
    <Link to="/" className="flex items-center gap-2.5 group" aria-label="瓜田吃瓜首页">
      <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-display text-xl leading-none transition-transform duration-300 group-hover:-rotate-6">
        瓜
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-display text-xl md:text-2xl tracking-wide ${textColor}`}>
          瓜田吃瓜
        </span>
        <span className={`text-[10px] tracking-[0.28em] uppercase mt-1 ${subColor}`}>
          Gua Tian
        </span>
      </span>
    </Link>
  );
}